<ng-container
  *ngIf="{
    quoteDetails: quoteDetails$ | async,
  } as content"
>
  @if (!content.quoteDetails?.isPristine) {
    @if (!content.quoteDetails?.isLoading) {
      @if (!content.quoteDetails?.hasError) {
        @if (content.quoteDetails?.quote) {
          <div class="page-title simple-card m-b-20">
            <page-title [pageTitle]="'Quote Details'" [isBackButtonVisible]="true" [backButtonTitle]="'Back to Quotes History'" [backButtonRedirectPage]="'quotes-history'"></page-title>
          </div>

          <div class="row">
            <div class="col-md-6 col-lg-8 col-12">
              <div class="simple-card custom-cx-card" *ngIf="content.quoteDetails?.quote">
                <cx-card [content]="transformQuoteIntoCard(content.quoteDetails?.quote!)"></cx-card>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 col-12">
              <div class="simple-card h-100" *ngIf="content.quoteDetails?.quote?.quoteCondition">
                <cx-card
                  [content]="{
                    header: 'quotes.quoteDetails.quoteConditions' | cxTranslate,
                    paragraphs: [
                      {
                        text: [content.quoteDetails?.quote?.quoteCondition || ''],
                      },
                    ],
                  }"
                ></cx-card>
              </div>
            </div>
            <div class="h6 px-4 m-t-12">
              {{ 'quotes.history.termsAndConditions1' | cxTranslate }}
              <a href="/terms-and-conditions"> {{ 'quotes.history.termsAndConditions2' | cxTranslate }} </a>
              {{ 'quotes.history.termsAndConditions3' | cxTranslate }}
            </div>
          </div>

          <div class="m-t-20">
            <quote-details-product-table [lineItems]="content.quoteDetails?.quote?.lines || []"></quote-details-product-table>
          </div>
        } @else {
          <p class="text-center ff-bold m-0">{{ 'quotes.quoteDetails.noContent' | cxTranslate }}</p>
        }
      }
    } @else {
      <local-loader></local-loader>
    }
  }
</ng-container>